import {$KTS, KeyTextStrings} from "@/shared/types";
import {BaseFragment} from "../shared/BaseFragment";
import {ModuleMain as HomeModuleMain} from "./home/ModuleMain";
import {ModuleMain as CheckinManagerModuleMain} from "./checkin-manager/ModuleMain";
import {ModuleMain as SmilebookDesignerModuleMain} from "./smilebook-designer/ModuleMain";
import {SvgIcon} from "@mui/material";
import {BookOutlined, HomeOutlined, TabletAndroidOutlined} from "@mui/icons-material";

export enum ModuleCategory {
  GENERAL = "general",
  DEVICES = "devices",
}

export const MODULE_CATEGORY_KTS = new KeyTextStrings([
  $KTS(ModuleCategory.GENERAL, "General"),
  $KTS(ModuleCategory.DEVICES, "Devices"),
]);

export enum ModuleName {
  HOME = "home",
  CHECKIN_MANAGER = "checkin-manager",
  SMILEBOOK_DESIGNER = "smilebook-designer",
}

export type Module = {
  MainFragment: typeof BaseFragment<any, any>,
  name: string,
  text: string,
  iconType: typeof SvgIcon,
  category: ModuleCategory,
}

export const MODULES: Module[] = [
  {
    MainFragment: HomeModuleMain,
    name: ModuleName.HOME,
    text: "Home",
    iconType: HomeOutlined,
    category: ModuleCategory.GENERAL,
  },
  {
    MainFragment: CheckinManagerModuleMain,
    name: ModuleName.CHECKIN_MANAGER,
    text: "Checkin Manager",
    iconType: TabletAndroidOutlined,
    category: ModuleCategory.DEVICES,
  },
  {
    MainFragment: SmilebookDesignerModuleMain,
    name: ModuleName.SMILEBOOK_DESIGNER,
    text: "Smilebook Designer",
    iconType: BookOutlined,
    category: ModuleCategory.DEVICES,
  },
];
